// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TicketResolve$ReactHooksTemplate = require("./ticketResolve.res.js");

function TicketResolveView(props) {
  var activity = props.activity;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Ticket Resolved",
                              className: "text-sm font-semibold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: TicketResolve$ReactHooksTemplate.user_email(activity),
                              className: "text-xs font-normal"
                            })
                      ],
                      className: "flex justify-between text-darkcharcoal"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        "RCA: ",
                        TicketResolve$ReactHooksTemplate.rca(activity)
                      ],
                      className: "flex text-xs font-normal mt-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: TicketResolve$ReactHooksTemplate.comment(activity),
                      className: "mt-2 text-xs font-normal"
                    })
              ]
            });
}

var make = TicketResolveView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
